export const settingsKeys = {
  practice: () => ['settings', 'practice'] as const,
  comms: () => ['settings', 'comms'] as const,
  locations: () => ['settings', 'locations'] as const,
  locationProfile: (locationId: string) => ['settings', 'location-profile', locationId] as const,
  locationLogo: (locationId: string) => ['settings', 'locations', locationId, 'logo'] as const,
  locationReviewQr: (locationId: string) =>
    ['settings', 'locations', locationId, 'review-qr'] as const,
  team: () => ['team'] as const,
  staffBase: (locationId: string) => ['settings', 'staff', locationId] as const,
  staff: (locationId: string, includeInactive: boolean) =>
    [...settingsKeys.staffBase(locationId), includeInactive] as const,
};

export const integrationKeys = {
  googleAdsStatusAll: () => ['integrations', 'google-ads', 'status'] as const,
  googleAdsStatus: (id: string) => ['integrations', 'google-ads', 'status', id] as const,
  metaAdsStatus: (id?: string) =>
    id
      ? (['integrations', 'meta-ads', 'status', id] as const)
      : (['integrations', 'meta-ads', 'status'] as const),
  gscStatus: (locationId: string) => ['integrations', 'gsc', 'status', locationId] as const,
  gbpStatus: (locationId: string) => ['integrations', 'gbp', 'status', locationId] as const,
  gscProperties: (token: string) => ['gsc', 'properties', token] as const,
  gbpListings: (token: string) => ['gbp', 'listings', token] as const,
  gscStatusShort: (locationId: string) => ['gsc', 'status', locationId] as const,
};

export const adSettingsKeys = {
  settings: (locationId: string) => ['ads', 'settings', locationId] as const,
  auctionInsights: (locationId: string) => ['ads', 'auction-insights', locationId] as const,
  appliedChange: (locationId: string, taskId: string) =>
    ['ads', 'applied-change', locationId, taskId] as const,
};
